import type { ChangePasswordInput } from "@api/auth/changePassword";

import { changePassword } from "@api/auth/changePassword";
import sendForgotPasswordCode from "@api/auth/sendForgotPasswordCode";
import { useMutation } from "@tanstack/react-query";

type SendCodeInput = { username: string };

export function useSendForgotPasswordCode() {
  return useMutation({
    mutationFn: async (input: SendCodeInput) => {
      const res = await sendForgotPasswordCode(input);
      if (!res?.success) {
        throw new Error("Unable to send code. Please try again later.");
      }
      return res.data;
    },
  });
}

export function useConfirmPasswordChange() {
  return useMutation({
    mutationFn: async (input: ChangePasswordInput) => {
      const res = await changePassword(input);
      if (!res?.success) {
        throw new Error("Unable to change password. Please try again later.");
      }
      return res.data;
    },
  });
}
